import ApiClient from "@common/api/ApiClient";

class SelfExclusionClient extends ApiClient {
  constructor() {
    super("SelfExclusion");
    this.setApiUrlKey("comp_api_url");
  }

  MetaData = async () => {
    return await this.get("Create");
  };

  Create = async (payload) => {
    return await this.post(`Create`, payload);
  };

  ReadForUpdate = async (id) => await this.get(`Update?id=${id}`);

  Read = async (id) => {
    const record = await this.get(`Read?id=${id}`);
    return { record };
  };

  Update = async (payload) => await this.post(`Update`, payload);
}

const client = new SelfExclusionClient();

export default client;
